import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import HotelLogin from "@/pages/HotelLogin";
import HotelDashboard from "@/pages/HotelDashboard";
import PublicLanding from "@/pages/PublicLanding";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#6B7280]">Caricamento...</div>;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/hotel/login"} replace />;
  if (role && user.role !== role) return <Navigate to={role === "admin" ? "/admin/login" : "/hotel/login"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Root → admin login direttamente (niente home generica) */}
            <Route path="/" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/hotel/login" element={<HotelLogin />} />
            <Route path="/hotel" element={<Protected role="hotel"><HotelDashboard /></Protected>} />
            {/* Landing pubblica white-label per ciascun hotel */}
            <Route path="/:hotelSlug/:citySlug" element={<PublicLanding />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
